/**
 * Utility functions for interacting with the CS2 Lens ML API
 */

interface TickPrediction {
  tick: number;
  t_win: number;
}

interface WinPredictionResponse {
  ticks: TickPrediction[];
}

const ML_API_ENDPOINT = 'https://vlwwqo3nfj.execute-api.eu-west-1.amazonaws.com';

/**
 * Fetches win predictions for specific ticks in a round
 * 
 * @param matchId - The match ID
 * @param mapName - The map name (without 'de_' prefix)
 * @param roundNum - The round number
 * @param ticks - Array of tick numbers to get predictions for
 * @returns Promise with the prediction results
 */
export const fetchWinPredictions = async (
  matchId: string,
  mapName: string,
  roundNum: number | string,
  ticks: number[]
): Promise<WinPredictionResponse> => {
  // Remove 'de_' prefix if present
  const cleanMapName = mapName.replace('de_', '');
  
  // Convert ticks array to comma-separated string
  const ticksParam = ticks.join(',');
  
  const url = `${ML_API_ENDPOINT}?match_id=${encodeURIComponent(matchId)}&mapname=${encodeURIComponent(cleanMapName)}&roundnum=${roundNum}&ticks=${ticksParam}`;
  
  try {
    const response = await fetch(url);
    
    if (!response.ok) {
      throw new Error(`ML API error: ${response.status} ${response.statusText}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching win predictions:', error);
    throw error;
  }
}

